import { AfterContentInit, Component, OnDestroy, OnInit } from '@angular/core';
import { MapLocationsService } from '../../shared/service/map-locations.service';
import { ActivatedRoute,Router } from '@angular/router';
import { LocationService } from '../../shared/service/location.service';
import { first } from 'rxjs/operators';
import { UrlDecider } from '../../shared/lib/url-decider';
@Component({
  selector: 'locations-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css','../../../locationStyles.scss'],
  providers: [MapLocationsService]
})
export class HomeComponent implements OnInit, AfterContentInit, OnDestroy {

  lang: any = {};
  language = 'eng';
  Lang = 'eng'
  mapDataSorted: any = [];
  mapLocations: any = [];
  uniqueStateNames: any = [];

  grpMR: any = [];
  grpAR: any = [];
  grpCSS: any = [];
  grpCorp: any = [];
  langSelector='eng';
  mapElementJS: any;
  PostalCode = '';
  Division = 'MRB,SMB';
  locationToggle:any={corporateOffice:true,metalsRecycling:false,autoRecycling:false,steelManufacturing:false}
  constructor(private mapService: MapLocationsService, private locationService: LocationService, private route: ActivatedRoute,private router: Router) {
    if (UrlDecider.getLangFromUrl()) { this.langSelector = UrlDecider.getLangFromUrl();}
  }

  ngOnInit() {
    if (this.route.snapshot.data['lang']) {
      this.Lang = UrlDecider.getLangFromUrl();
    }
    this.loadLanguage();
  }

  ngAfterContentInit() {
    this.getMapData();
  }

  ngOnDestroy() {
    if(this.mapElementJS){
    document.getElementsByTagName('head')[0].removeChild(this.mapElementJS);
  }
  }

  loadLanguage() {
    this.locationService.GetLocationLang(UrlDecider.getLangFromUrl()).pipe(first())
      .subscribe((langJson) => {
        this.lang = langJson;
      });
  }

  loadScript() {
    this.mapElementJS = document.createElement('script');
    this.mapElementJS.src = 'assets/js/map.js';
    this.mapElementJS.type = 'text/javascript';
    this.mapElementJS.async = true;
    this.mapElementJS.charset = 'utf-8';
    document.getElementsByTagName('head')[0].appendChild(this.mapElementJS);
  }

  getMapData() {
    this.mapService.getMapLocations().subscribe((data: any) => {
      (window as any).mapLocationsData = data; // TODO tech debt
      this.mlSort(data);
      this.loadScript();
    });

  }

  mlSort(data: any) {

    // METALS RECYCLING = MRB
    // AUTO RECYCLING = APB || PNP
    // CASCADE STEEL AND SCRAP = SMB

    const columnLimit = 10;
    const corpColLimit = 0;
    let corpPos = 0;
    let metalPos = 0;
    let autoPos = 0;
    let scrapPos = 0;

    const states: any = [...new Set(data.map((item: any) => item.state === 'Outside US' ? item.countryName : item.state))];

    const divisions: any = [...new Set(data.map((item: any) => item.division))];
    divisions.sort();

    let corpTemp = [];
    let cmTemp = [];
    let caTemp = [];
    let csTemp = [];

    for (let i = 0; i < divisions.length; i++) {
      // Corporate

      const corplocations = data.filter((x: any) => x.division === divisions[i] && x.corporateOffice === true);
      if (divisions[i] === 1) {
        corplocations.corpDiv = this.lang.CorporateHeadquarters;
      }
      if (divisions[i] === 2) {
        corplocations.corpDiv = this.lang.MetalsRecycling;
      }
      if (divisions[i] === 3) {
        corplocations.corpDiv = this.lang.AutoParts;
      }
      if (divisions[i] === 4) {
        corplocations.corpDiv = this.lang.SteelManufacturing;
      }

      if (corplocations.length > 0) {
        corpTemp.push({ division: divisions[i], corpDiv: corplocations.corpDiv, locations: corplocations });
      }

      corpPos += corplocations.length;
      if (corpPos > corpColLimit) {
        this.grpCorp.push({ cdata: corpTemp });
        corpPos = 0;
        corpTemp = [];
      }
    }

    for (let i = 0; i < states.length; i++) {

      // Metals
      let mlocations = data.filter((x: any) => x.state === states[i] && x.divisionCode === 'MRB');
      const mprlocations = data.filter((x: any) => x.countryName === states[i] && x.divisionCode === 'MRB');

      mlocations = mlocations.concat(mprlocations);

      if (mlocations.length > 0) {
        cmTemp.push({ state: states[i], locations: mlocations });
      }

      metalPos += mlocations.length;
        
      if (metalPos > columnLimit) {
        this.grpMR.push({ cdata: cmTemp });
        metalPos = 0;
        cmTemp = [];
      }

      // Autos
      const alocations = data.filter((x: any) => x.state === states[i] && (x.divisionCode === 'APB' || x.divisionCode === 'PNP'));

      if (alocations.length > 0) {
        caTemp.push({ state: states[i], locations: alocations });
      }

      autoPos += alocations.length;

      if (autoPos > columnLimit) {
        this.grpAR.push({ cdata: caTemp });
        autoPos = 0;
        caTemp = [];
      }

      // Scrap
      const slocations = data.filter((x: any) => x.state === states[i] && x.divisionCode === 'SMB');

      if (slocations.length > 0) {
        csTemp.push({ state: states[i], locations: slocations });
      }

      scrapPos += slocations.length;

      if (scrapPos > columnLimit) {
        this.grpCSS.push({ cdata: csTemp });
        scrapPos = 0;
        csTemp = [];
      }

    }

    this.grpCorp.push({ cdata: corpTemp });
    this.grpMR.push({ cdata: cmTemp });
    this.grpAR.push({ cdata: caTemp });
    this.grpCSS.push({ cdata: csTemp });

  }
  onLocationClickToggle(name:any){
    for (const [key, value] of Object.entries(this.locationToggle)) {
      key === name ? (this.locationToggle[key] = true) : (this.locationToggle[key] = false);
    }
  }
  navigateToLocationSearch() {
    if (this.langSelector === 'es')
      return this.router.navigate(['/instalaciones/buscar', { zip: this.PostalCode, div: this.Division }]);
    else
      return this.router.navigate(['/locations/search', { zip: this.PostalCode, div: this.Division }]);
  }
}
